import to from 'await-to-js'
import router from '@/router'
import routeNames from '@/router/route-names'
import buildClient from '@/api/client'
import shoeFinderQuery from '@/api/shoe-finder'
import { formatVariants } from '@/components/FilterPage/transformation-helpers.js'

const DETAIL_PAGE_DELAY = 1000

function redirectToFilterPage(hostname, locale) {
  window.location.href = `${hostname}/${locale}/explore`
}

function validateProductGroup(items, slug) {
  return Boolean(
    items.filter(item => item.product.variants[0].spreeProduct.groupSlug === slug).length
  )
}

export default {
  namespaced: true,
  state: {
    answeredQuestionsCount: 0,
    detailSpecs: {},
    initialProductGroup: undefined,
    isDataReady: false,
    isDetailViewActive: false,
    hoveredSpecs: [],
    items: [],
    sortedItems: [],
    questions: [],
    scrollBreakpointMax: 950,
    specs: {},
  },

  mutations: {
    setState(state, payload) {
      for (let key in payload) state[key] = payload[key]
    },

    setSpec(state, payload) {
      state.specs[payload.category] = payload.value
    },

    setDetailSpecs(state, payload) {
      state.detailSpecs = payload
    },

    setDetailViewActive(state, payload) {
      state.isDetailViewActive = payload
    },

    setAnsweredQuestionsCount(state, payload) {
      state.answeredQuestionsCount = payload
    },

    setInitialProductGroup(state, payload) {
      state.initialProductGroup = payload
    },

    addHoverSpecs(state, payload) {
      state.hoveredSpecs.push(payload)
    },

    setDataReady(state) {
      state.isDataReady = true
    },

    clearHoverSpecs(state) {
      state.hoveredSpecs = []
    },

    setSortedItems(state, payload) {
      state.sortedItems = payload
    },

    formatVariants(state) {
      state.items.forEach(item => {
        formatVariants(item.product)
      })
    },
  },

  actions: {
    async fetchData({ state, commit, dispatch, rootState }) {
      const productGroup = rootState.route.params.productGroup
      const [error, data] = await to(buildClient().query(shoeFinderQuery()))
      if (error) return redirectToFilterPage(rootState.page.hostname, rootState.page.locale)

      commit('setState', data.shoeFinder)
      commit('formatVariants')
      dispatch('sortItems')

      const isValidProductGroup = validateProductGroup(state.items, productGroup)
      if (!isValidProductGroup) dispatch('handleRoute', { action: 'replace', slug: undefined })
      else if (productGroup) commit('setInitialProductGroup', productGroup)

      setTimeout(() => commit('setDataReady'), productGroup ? DETAIL_PAGE_DELAY : 0)
      document.querySelector('.site-footer').classList.remove('site-footer--hidden')
    },

    sortItems({ state, commit }) {
      const sortedItems = JSON.parse(JSON.stringify(state.items))
      sortedItems.sort((a, b) => b.relevance - a.relevance)
      commit('setSortedItems', sortedItems)
    },

    calculateRelevance({ state }) {
      state.items.forEach(item => {
        item.relevance = 0
        for (let spec in state.specs) {
          if (state.specs.hasOwnProperty(spec)) {
            const specValue = state.specs[spec]
            const relevance = item.specs[spec][specValue]
            if (relevance != undefined) {
              item.relevance += relevance
            }
          }
        }
      })
    },

    handleRoute(undefined, payload) {
      router[payload.action]({
        name: routeNames.shoeFinder,
        params: { productGroup: payload.slug },
      })
    },
  },
}
